import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../../style/btCountry.css';

const data = [
    {
        id: 'nsc',
        name: '那受村',
        coords: "309, 249, 398, 329, 327, 391, 261, 344, 303, 334, 320, 312, 345, 309, 299, 278",
        mCoords: '211, 275, 249, 200, 276, 204, 322, 266, 265, 316',
        map: require('../../assets/nsc_map.png'),
        text: '那受村位于育才生态区东部山区，东至南岛，西到马脚，北接那会，南靠马亮。全村土地面积约有8000多亩 ，其中耕地面积2431亩，林地面积4158 亩，其他农用地面积1411亩。全村共8个村小组，总人口521户2463人，其中:黎族2060人，占比83.6%，苗族403人占比16.4%。',
        pic: require('../../assets/nsc.jpg')
    },
    {
        id: 'lmc',
        name: '龙密村',
        coords: "218, 402, 254, 396, 277, 416, 314, 415, 340, 465, 330, 477, 231, 461, 198, 462, 188, 450, 188, 464, 175, 454, 160, 450, 130, 430, 146, 414, 159, 428, 183, 429, 192, 445, 205, 440, 209, 461, 230, 460, 229, 447, 241, 446, 216, 419",
        mCoords: '253, 336, 218, 330, 206, 321, 177, 324, 185, 364, 118, 335, 109, 353, 187, 371, 269, 384',
        map: require('../../assets/lmc_map.png'),
        text: '龙密村总面积9.97平方公里，耕地面积2627 亩，其中水田面积1955亩，坡园地面积6000亩，其他（水塘、草地）150亩。下辖15个自然村，673户3273人；主要以种植芒果、槟榔、香蕉、冬季瓜菜，养殖鸡、鸭、黑山羊及外出务工为主要经济收入来源，2020年村集体收入8.93万元，人均纯收入13720元。',
        pic: require('../../assets/lmc.jpg')
    },
    {
        id: 'mlc',
        name: '马亮村',
        coords: "243, 396, 255, 376, 270, 375, 274, 360, 287, 360, 327, 391, 314, 413, 283, 413, 255, 396, 243, 397",
        mCoords: "254, 334, 265, 317, 225, 289, 198, 317",
        map: require('../../assets/mlc_map.png'),
        text: '马亮村位于育才生态区西面，距离区管委约4.8公里，马亮村辖区面积5.44平方千米，确权的土地面积3444.97亩，其中耕地1445.01亩，林地1705.96亩，其他294亩，主要种植水稻、冬季瓜菜、槟榔、芒果等作物。全村共8个自然村9个村民小组，总人口415户1950人。',
        pic: require('../../assets/mlc.jpg')
    },
    {
        id: 'mjc',
        name: '马脚村',
        coords: "195, 326, 209, 357, 241, 376, 243, 355, 263, 347, 277, 357, 270, 376, 250, 378, 242, 397, 204, 398, 193, 416, 156, 406, 167, 371, 188, 366, 188, 338",
        mCoords: "129, 326, 159, 264, 220, 289, 183, 322, 156, 332",
        map: require('../../assets/mjc_map.png'),
        text: '马脚村，因大力神神话故事“马脚印”而得名，位于三亚市育才生态区中部，S314省道横穿马脚村，距三亚市主城区45公里，距三亚凤凰机场33公里。辖区总面积约15.16平方公里，全村土地面积8687亩，其中耕地面积2337亩，林地面积5050亩，其他农用地面积1300亩。农民主要依靠种植芒果、槟榔、诺丽果、水稻等作物，全村人均年收入12800元。下辖8个村小组，常住总人口536户2539人，其中黎族2508人，占比近99%。',
        pic: require('../../assets/mjc.png')
    },
    {
        id: 'nhc',
        name: '那会村',
        coords: "326, 245, 350, 190, 413, 151, 432, 194, 448, 202, 428, 213, 389, 311",
        mCoords: '265, 198, 293, 145, 333, 123, 363, 166, 319, 247',
        map: require('../../assets/nhc_map.png'),
        text: '那会村位于育才生态区北部，辖区面积26.9平方公里，共6个村小组，总人口250户1265人。全村耕地面积259亩，林地面积约19200亩。现阶段主要以农业生产为主导产业，以种植橡胶、槟榔、芒果、冬季瓜菜为主，同时大力发展鸡、鸭等禽畜养殖业及林下种植经济。',
        pic: require('../../assets/nhc_pic2.jpg')
    },
    {
        id: 'ylc',
        name: '雅亮村',
        coords: "107, 301, 144, 311, 173, 283, 192, 308, 141, 391, 119, 381, 124, 352, 100, 330",
        mCoords: '118, 315, 100, 304, 101, 282, 85, 286, 90, 244, 123, 249, 142, 228, 157, 246',
        map: require('../../assets/ylc_map.png'),
        text: '雅林村地处育才生态区西北部，距离育才生态区管委会约19公里，西面与乐东县富保农场相连，南面与南滨农场接壤。四周环山，森林茂密属丘陵地山区，盆地状，平均海拔为450米，最高海拔为820米，全村土地面积22025亩，其中耕地3891亩，林地3138亩，其他农用地约14000亩，两宗水库。全村共18个村民小组，户籍人口1037户4257人，常住人口845户3933人，以黎族为主。',
        pic: require('../../assets/ylc.jpg')
    },
    {
        id: 'qfc',
        name: '青法村',
        coords: "106, 299, 144, 309, 172, 281, 203, 293, 261, 257, 266, 248, 249, 244, 233, 254, 223, 217, 197, 213, 175, 238, 165, 233, 159, 245, 117, 239",
        mCoords: '88, 241, 89, 195, 163, 173, 213, 205, 155, 238, 141, 225, 118, 248',
        map: require('../../assets/qfc_map.png'),
        text: '青法村位于三亚市育才生态区西北部，东邻大隆水库，南接雅亮村委会，西至雅林村委会，北接明善村委会和保国农场，总面积15.5平方公里。全村共有6个自然村9个村民小组，总人口416户2293人。可耕种土地9592亩，其中耕地 3161亩，（水田2165亩、旱田996亩），林地4445亩,坡地1551亩，其它地435亩。村民经济收入主要以种养为主，外出或者灵活务工、加工业酿酒为辅。种植业主要种芒果、槟榔、橡胶、水稻、冬季瓜菜、花生等；养殖业主要养生猪、鸡、山羊、乳鸽等。',
        pic: require('../../assets/qfc.jpg')
    },
    {
        id: 'msc',
        name: '明善村',
        coords: "115, 237, 150, 246, 166, 233, 176, 237, 198, 212, 174, 176, 131, 153, 64, 161, 42, 169, 40, 192, 61, 208, 77, 206",
        mCoords: '159, 169, 112, 125, 40, 133, 35, 155, 90, 191',
        map: require('../../assets/msc_map.png'),
        text: '明善村位于育才生态区西北部，北邻保国农场，南接青法村，东保国农场九队，西至毫赖岭。全村土地面积为9525亩，其中耕地面积为1365.64亩，林地面积约9320亩，其他农用地面积5000多亩，下辖8个村民小组。',
        pic: require('../../assets/msc.jpg')
    },
    {
        id: 'ylic',
        name: '雅林村',
        coords: "38, 195, 19, 209, 7, 246, 26, 347, 46, 352, 66, 389, 117, 391, 125, 352, 100, 331, 111, 272, 100, 231, 69, 205, 59, 209",
        mCoords: '32, 157, 86, 195, 82, 268, 101, 286, 95, 314, 55, 311, 22, 278, 7, 222',
        map: require('../../assets/ylic_map.png'),
        text: '雅林村地处育才生态区西北部，距离区管委会行政办公区约19公里，西面与乐东县富保农场相连，南面与南滨农场接壤。四周环山，森林茂密属丘陵地山区，盆地状，平均海拔为450米，最高海拔为820米，全村土地面积22025亩，其中耕地3891亩，林地3138亩，其他农用地约14000亩，两宗水库。全村共18个村民小组，户籍人口1037户4257人，常住人口845户3933人，以黎族为主。',
        pic: require('../../assets/ylc.jpg')
    },
    {
        id: 'bac',
        name: '抱安村',
        coords: "264, 175, 276, 239, 307, 116, 378, 77, 449, 15, 473, 68, 493, 122, 420, 149, 390, 173, 357, 182, 318, 249, 293, 241",
        mCoords: '261, 199, 292, 140, 316, 139, 362, 100, 394, 98, 368, 15, 215, 140, 224, 191',
        map: require('../../assets/bac_map.png'),
        text: '抱安村委会位于三亚市育才生态区西北部，位于三亚与乐东的交界处，是三亚最偏远的乡村之一，距离三亚市内80公里、距离育才生态区管委办公区42公里。是黎族苗族居住的古老村庄，下辖南来、抱安、抱安二、保文、保文二、保文三等6个村小组，共261户1326人。',
        pic: require('../../assets/bac.jpg')
    }
];

function BtCountry() {

    const [curCou, setCurCou] = useState(data[0]);
    const [isPhone, setIsPhone] = useState(false);

    useEffect(() => {
        // 手机端设置
        if (window.innerWidth > 768) {
            setIsPhone(false);
        } else {
            setIsPhone(true);
        }
    }, [])

    return (
        <div className="btCountry">
            <div className="btCountry-pic">
                {
                    data.map(item =>
                        <img
                            key={item.id}
                            id={item.id}
                            className="btCountry-pic__img"
                            src={item.map}
                            alt="Planets"
                            useMap="#planetmap"
                            style={{ display: item.id === curCou.id ? 'block' : 'none' }}
                        />
                    )
                }
                <map name="planetmap" id="regionMap">
                    {
                        data.map(item =>
                            <area
                                key={item.id}
                                name="btCountry1"
                                shape="poly"
                                coords={isPhone ? item.mCoords : item.coords}
                                style={{ cursor: 'pointer' }}
                                onClick={() => window.location.href = `/btdetails#${item.id}`}
                                onMouseMove={() => setCurCou(item)}
                                alt="btCountry1"
                            />
                        )
                    }
                </map>
            </div>
            <div className="btCountry-intro">
                <div className="btCountry-intro__name">{curCou.name}</div>
                <p className="btCountry-intro__text">{curCou.text}</p>
                <button className="btCountry-intro__btn">
                    <Link to={`/btdetails#${curCou.id}`}>
                        查看更多
                    </Link>
                </button>
                <img className="btCountry-intro__pic" src={curCou.pic} alt="美丽乡村" />
            </div>
        </div>
    );
}

export default BtCountry;
